// Module
var code = "<a data-bind=\"click: Click, tooltip: {content: SaveBtnText}\" data-testid=\"edit.save\" tabindex=\"-1\" class=\"text-sm sps-btn sps-btn-outline btn-color-static-save saveButton\" id=\"saveBtn\"> <i class=\"fa fa-save\"></i><span><!-- ko text: _labels.SAVE --><!-- /ko --></span> </a>";
// Exports
export default code;